"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INVENTORY_HISTORY = void 0;
var INVENTORY_HISTORY = {
  LABEL__TRACK_PRODUCT: 'inventoryHistory-label-productTracking',
  BUTTON__EXPORT_CSV: 'inventoryHistory-button-exportCSV',
  BUTTON__FILTER_ACTIONS: 'inventoryHistory-button-actions',
  BUTTON__FILTER_WAREHOUSE: 'inventoryHistory-button-warehouse',
  BUTTON__DATE_PICKER: 'inventoryHistory-button-datePicker',
  ICON__LOG_TYPE: 'inventoryHistory-icon-logType',
  TEXT__LOG_TYPE: 'inventoryHistory-span-logType',
  TEXT__DATE_CREATED: 'inventoryHistory-span-createdAt',
  TEXT__USER: 'inventoryHistory-span-user',
  TEXT__WAREHOUSE: 'inventoryHistory-span-warehouse',
  TEXT__BATCH_CODE: 'inventoryHistory-span-batchCode',
  TEXT__REFERENCE: 'inventoryHistory-span-reference',
  TEXT__COGS: 'inventoryHistory-span-cogs',
  TEXT__ADJUSTMENT: 'inventoryHistory-span-adjustment',
  TEXT__STOCK: 'inventoryHistory-span-stock'
};
exports.INVENTORY_HISTORY = INVENTORY_HISTORY;